import { PeopleOutline, PersonAddAlt1Outlined, AttachMoneyOutlined } from '@mui/icons-material';
import { MetricCard, type MetricCardProps } from 'finara-components';
import React from 'react';

import { useClientAnalytics } from '@/hooks/queries/useSuperAdminClients';

// Note: These cards show global analytics, not filtered by search/status/type
// The filtering only applies to the table below
export const ClientSummaryCards: React.FC = () => {
  const { data: analytics, isLoading } = useClientAnalytics();

  // Format currency
  const formatCurrency = (value: number) => {
    if (value >= 1000000) {
      return `$${(value / 1000000).toFixed(1)}M`;
    }
    return `$${value.toLocaleString()}`;
  };

  // Format percentage change
  const formatChange = (change: number) => {
    const sign = change >= 0 ? '+' : '';
    return `${sign}${change.toFixed(1)}% vs mes anterior`;
  };

  const clientMetrics: Record<string, MetricCardProps> = {
    clientesActivos: {
      title: 'Total Clientes Activos',
      value: isLoading ? '...' : (analytics?.totalActiveClients.toString() ?? '0'),
      trendingUpText:
        !isLoading && analytics?.totalActiveClientsChange
          ? formatChange(analytics.totalActiveClientsChange)
          : undefined,
      icon: <PeopleOutline className="text-green-500" fontSize="inherit" />,
      iconBackground: 'bg-green-100',
    },
    personasActivas: {
      title: 'Total Personas Activas',
      value: isLoading ? '...' : (analytics?.totalActivePersons.toLocaleString() ?? '0'),
      trendingUpText:
        !isLoading && analytics?.totalActivePersonsChange
          ? formatChange(analytics.totalActivePersonsChange)
          : undefined,
      icon: <PersonAddAlt1Outlined className="text-blue-500" fontSize="inherit" />,
      iconBackground: 'bg-blue-100',
    },
    clientesInactivos: {
      title: 'Total Clientes Inactivos',
      value: isLoading ? '...' : (analytics?.totalInactiveClients.toString() ?? '0'),
      icon: <PeopleOutline className="text-red-500" fontSize="inherit" />,
      iconBackground: 'bg-red-100',
    },
    volumenOperaciones: {
      title: 'Volumen Total Operaciones 30d',
      value: isLoading ? '...' : formatCurrency(analytics?.totalVolume30d ?? 0),
      trendingUpText:
        !isLoading && analytics?.totalVolume30dChange
          ? formatChange(analytics.totalVolume30dChange)
          : undefined,
      icon: <AttachMoneyOutlined className="text-purple-500" fontSize="inherit" />,
      iconBackground: 'bg-purple-100',
    },
  };

  return (
    <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {Object.entries(clientMetrics).map(([key, metric]) => (
        <MetricCard
          size="small"
          key={key}
          title={metric.title}
          value={metric.value}
          trendingUpText={metric.trendingUpText}
          icon={metric.icon}
          iconBackground={metric.iconBackground}
        />
      ))}
    </div>
  );
};
